import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import WeeklyMissionsList from './WeeklyMissionsList';

function WeeklyMissions(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderBagdes = () => {
    const missions = loadMissions();
    if (missions) {
      return (
        <div className="row">
          <WeeklyMissionsList missions={missions} />
        </div>
      );
    }
  };

  const loadMissions = () => {
    const { weeklyMissions } = props;
    if (weeklyMissions) {
      let missionsList = [];
      for (var key in weeklyMissions) {
        var value = { ...weeklyMissions[key] };
        value.id = key;
        missionsList.push(value);
      }
      return missionsList;
    }
  };

  return (
    <div className="dashboard container">
      {renderBagdes()}
      <Link className="btn-floating btn-large fixed-action-btn green right" to="newMission">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    weeklyMissions: state.firestore.data.weeklyMission,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([{ collection: 'weeklyMission' }]))(WeeklyMissions);
